// Subscription figures as the screens show them (plans table, the organization's Subscription tab).
import { num } from '@/api/types';

type SubLike = {
  period: string;
  plan_snapshot: Record<string, unknown>;
  discount_percent: number | null;
  discount_reason: string | null;
  contract_ref: string | null;
};

/** Per month, the way the API computes MRR: a yearly amount is divided by 12. */
export function monthly(amount: string | number, period: string): number {
  const v = num(amount);
  return period === 'yearly' ? Math.round(v / 12) : v;
}

/** The plan name frozen into the subscription (plan_snapshot.name). */
export function planName(sub: { plan_snapshot: Record<string, unknown> }): string {
  const n = sub.plan_snapshot.name;
  return typeof n === 'string' ? n : '';
}

/** «15» for 15.0, «12,5» for 12.5. */
export function pct(v: number): string {
  return Number.isInteger(v) ? String(v) : String(v).replace('.', ',');
}

/** «−15% · договор №118», «−10% · объём», or null without a discount. */
export function discountLabel(sub: SubLike, t: (k: string, o?: Record<string, unknown>) => string): string | null {
  if (!sub.discount_percent) return null;
  const reason = sub.contract_ref ? t('subs.contract', { ref: sub.contract_ref }) : sub.discount_reason;
  return reason ? t('subs.discount', { pct: pct(sub.discount_percent), reason }) : `−${pct(sub.discount_percent)}%`;
}
